import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

import {
    getFromRootWithoutAuthorisation
} from 'actions/requests'

class Footer extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      platform: [],
      platformLoaded: false
    };
  }
  
  componentDidMount() {
      
      document.body.style.overflow = "unset";

      getFromRootWithoutAuthorisation(`actuator/info`)
          .then((result) => {
            this.setState({ 
              ...this.state,
              platform: result.app, 
              platformLoaded: true 
            })
          }
            );
  }


  render() {

  const {platform,platformLoaded}  = this.state;

  const { classes, fluid, white } = this.props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });

  return (
    <footer className={classes.footer}>
      <div className={container}>
          {platformLoaded ? (
              <p className={classes.right}>
                  &copy; {1900 + new Date().getYear()}{" "}
                  ScopeMarkets &nbsp;<sub style={{fontSize:10}}>{process.env.REACT_APP_VERSION}</sub>
                  <br/>Platform: {(platform)? platform.environment+'_'+platform.version:''}
              </p>
          ) : (
              <p className={classes.right}>
                 User Loading
              </p>
          )}
      </div>
    </footer>
  );
}

}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx